'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepBadge } from '../pipeline-step-badge';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';

interface IPopulateStepProps {
  item: ICollectionPipelineStatusV3;
}

function resolveDisabled(item: ICollectionPipelineStatusV3): string | undefined {
  if (item.steps.extracted.ranAt === null) {
    return 'Extract not run yet';
  }
  return undefined;
}

export function PopulateStep({ item }: IPopulateStepProps): JSX.Element {
  const { populated } = item.steps;
  const disabled = resolveDisabled(item);

  return (
    <PipelineStepCell
      badge={<PipelineStepBadge step={populated} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Populate"
          description={`Fill challenge fields (definition, examples, audio refs) using AI for every linked challenge. ${populated.done}/${populated.total} populated.`}
          dataHref={`/sys/challenges/populate?collectionSlug=${item.slug}`}
          dataLabel={disabled ? 'Open populate (prereq missing)' : 'Open populate page'}
        />
      )}
    />
  );
}
